import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  container: {
    position: 'relative',
  },

  // TODO: remove the following
  removeButton: {
    position: 'absolute',
    top: '-0.5rem',
    left: '-0.5rem',
  },

  button: {
    display: 'inline-block',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    userSelect: 'none',
    padding: '.3125rem .5625rem',
    border: '.0625rem solid transparent',
    borderRadius: t.buttonBorderRadius,
    fontSize: '.875rem',
    position: 'relative',
    transition: 'box-shadow 200ms ease',
    textDecoration: 'none',
    lineHeight: 1.15,
    minHeight: '1.75rem',
    minWidth: '1.75rem',
    color: t.buttonDefaultColor,
    backgroundColor: t.buttonDefaultBgColor,
    borderColor: t.buttonDefaultBorderColor,
    animation: '$show .6s ease',
    opacity: 0.6,

    '&:hover': {
      color: t.buttonDefaultColor,
      opacity: 1,
    },

    '&:focus, &:active:focus': {
      outline: '0',
      boxShadow: `0 0 0 .1875rem ${t.buttonDefaultFocusColor}`,
    },

    '&:active, &:focus:active': {
      position: 'relative',
      top: '.0625rem',
    },
  },

  '@keyframes show': {
    '0%': {
      display: 'none',
      opacity: 0,
    },
    '1%': {
      display: 'block',
      opacity: 0,
    },
    '100%': {
      opacity: 0.6,
    },
  },
}))

export default useStyles
